var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SliceAction',{attrs:{"slice":_vm.slice,"item":_vm.item}})
}
var staticRenderFns = []

export { render, staticRenderFns }